module.exports = __webpack_public_path__ + "media/application/images/partners/wjc-99d5e4f3b3936fb4eb95d493695daae9c083ad00be0a14456ce87a7d2013f291.png";